document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    function initializeShareButtons() {
        const $shareButton = $('.shareBtn');

        $shareButton.off('click.share').on('click.share', function(event) {
            const elem = $(this);
            const url = elem.data('copy');
            const title = elem.data('title');

            copyToClipboardShare(elem);

            if (navigator.share) {
                navigator.share({
                    title: title,
                    url: url
                }).then(() => {
                    // console.log('Done!');
                }).catch(console.error);
            } else {
                copyToClipboardShare(elem);
            }
        });
    }

    function copyToClipboardShare(elem) {
        if (!$(elem).closest('.card').length) {
            $(elem).addClass('copyToClipboard');
        }

        var text = $(elem).attr('data-copy');
        var succeed;

        try {
            var el = document.createElement('textarea');
            el.value = text;
            document.body.appendChild(el);
            el.select();
            succeed = document.execCommand('copy');
            document.body.removeChild(el);
        } catch (e) {
            console.warn(e);
            succeed = false;
        }

        if (succeed) {
            $(elem).find(".copyToClipboard__copied").animate({ top: -20, opacity: 1 }, 700, function() {
                $(this).css({ top: -5, opacity: 0 });
            });
        }

        return succeed;
    }

    initializeShareButtons();
});
